import React from "react";
import PropTypes from "prop-types";

import ProductSelection from "../components/ProductSelection/ProductSelection";
import MiniSteps from "../../../../components/MiniSteps/MiniSteps";
import useNuveiViewModel, {ViewMode} from "./Nuvei.vm";
import CustomerInfoForm from "./components/CustomerInfoForm/CustomerInfoForm";
import TransactionProcessing from "./components/TransactionProcessing/TransactionProcessing";
import TransactionCompleted from "../components/TransactionCompleted/TransactionCompleted";
import TransactionFailed from "../components/TransactionFailed/TransactionFailed";
import "./Nuvei.scss";

const NuveiContext = React.createContext({});

const Nuvei = (props)=>{

    const vm = useNuveiViewModel(props);
    return (
        <div className={"Nuvei AddFundsContent step_" + vm.viewMode + ""}>
            <NuveiContext.Provider value={vm}>
                {{
                    [ViewMode.PRODUCT_SELECTION]: ()=><ProductSelection vm={vm} />,
                    [ViewMode.CUSTOMER_INFO_FORM]: ()=><>
                        <TransactionProcessing vm={vm}
                                               style={{display: vm.submitting ? 'block' : 'none'}}/>
                        <CustomerInfoForm vm={vm}
                                          style={{display: vm.submitting ? 'none' : 'block'}}/></>,
                    [ViewMode.TRANSACTION_PROCESSING]:()=><TransactionProcessing vm={vm}/>,
                    [ViewMode.TRANSACTION_COMPLETED]:()=><TransactionCompleted vm={vm}/>,
                    [ViewMode.TRANSACTION_FAILED]:()=><TransactionFailed vm={vm}/>
                }[vm.viewMode]()}

                {vm.steps.includes(vm.viewMode) &&
                    <MiniSteps steps={vm.steps}
                               currentStep={vm.viewMode}
                               onStepClick={v => {
                                   vm.setViewMode(v);
                               }}
                    />}
            </NuveiContext.Provider>
        </div>)
}

Nuvei.propTypes = {
    showCloseBtn: PropTypes.bool,
    close: PropTypes.func,
};

export default Nuvei;